import { useEffect, useRef } from "react";
// import { GetCategoryDetail } from "../../../services/StudentService";
import "jspdf-autotable";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import React, { useState, Component } from "react";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertFromRaw, convertToRaw, ContentState, Modifier, Entity, AtomicBlockUtils, RichUtils } from "draft-js";
import PropTypes from 'prop-types';
import { BlockPicker } from 'react-color';
import { CKEditor } from 'ckeditor4-react';
import { API_BASE, DOMAIN_COLOR, IMAGE_URL } from "../../utils/Constants";
import FileSystem from "./FileSystem";
import PopupComponent from "./PopupComponent";
import $ from "jquery";
import { getToken } from "../../utils/Auth";
import { useDispatch } from "react-redux";
import { setFileSystemType } from "../../store/actions";
// import SimpleUploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/simpleuploadadapter';

class ColorPic extends Component {

  constructor(props) {
    super(props);
    this.state = {
      hexColor: "#000",
      expanded: false
    }
    this.handleExpand = this.handleExpand.bind(this);
  }


  static propTypes = {
    onExpandEvent: PropTypes.func,
    onChange: PropTypes.func,
    currentState: PropTypes.object,
  };

  onChange = (color) => {
    this.setState({ hexColor: color.hex });
    const { onChange, editorState } = this.props;
    // const { editorState, onChange } = this.props;
    // RichUtils.toggleInlineStyle(
    //       editorState,
    //       'CODE'
    //     )
    onChange('color', color.hex);


    // const newState = RichUtils.toggleInlineStyle( editorState, 'CODE');
    // const { editorState, onChange } = this.props;
    //   const newState = RichUtils.toggleInlineStyle(
    //     editorState,
    //     'CODE'
    //   );
    //   if (newState) {
    //     onChange(newState);
    //   }
  }

  handleExpand() {
    this.setState({ expanded: !this.state.expanded });
  }

  stopPropagation = (event) => {
    event.stopPropagation();
  };

  renderModal = () => {
    // const { color } = this.props.currentState;
    return (
      <div
        className="rdw-link-modal custom-picker"
        onClick={this.stopPropagation}
      >
        <BlockPicker color={this.state.hexColor} onChangeComplete={this.onChange} />
      </div>
    );
  };

  render() {
    const { expanded, onExpandEvent } = this.props;
    return (
      <div className="rdw-link-wrapper" aria-haspopup="true" aria-label="rdw-color-picker" >
        <div className="rdw-option-wrapper" onClick={this.handleExpand} >
          <img src={'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTQuNDA2LjU4NWExLjk5OCAxLjk5OCAwIDAgMC0yLjgyNSAwbC0uNTQuNTRhLjc0MS43NDEgMCAxIDAtMS4wNDggMS4wNDhsLjE3NS4xNzUtNS44MjYgNS44MjUtMi4wMjIgMi4wMjNhLjkxLjkxIDAgMCAwLS4yNjYuNjAybC0uMDA1LjEwOHYuMDAybC0uMDgxIDEuODI5YS4zMDIuMzAyIDAgMCAwIC4zMDIuMzE2aC4wMTNsLjk3LS4wNDQuNTkyLS4wMjYuMjY4LS4wMTJjLjI5Ny0uMDEzLjU3OS0uMTM3Ljc5LS4zNDdsNy43Ny03Ljc3LjE0Ni4xNDRhLjc0Ljc0IDAgMCAwIDEuMDQ4IDBjLjI5LS4yOS4yOS0uNzU5IDAtMS4wNDhsLjU0LS41NGMuNzgtLjc4Ljc4LTIuMDQ0IDAtMi44MjV6TTguNzk1IDcuMzMzbC0yLjczLjUxNSA0LjQ1Mi00LjQ1MiAxLjEwOCAxLjEwNy0yLjgzIDIuODN6TTIuMDggMTMuNjczYy0xLjE0OCAwLTIuMDguMjk1LTIuMDguNjYgMCAuMzYzLjkzMi42NTggMi4wOC42NTggMS4xNSAwIDIuMDgtLjI5NCAyLjA4LS42NTkgMC0uMzY0LS45My0uNjU5LTIuMDgtLjY1OXoiLz48L2c+PC9zdmc+'} alt="" />
        </div>
        {this.state.expanded ? this.renderModal() : undefined}
      </div>
    );
  }
}

function HtmlInputEditor({ editorState, setEditorState, initialValue,readOnly, hideSign, belowNoMargin, isCKEditor, isInvalid = false , from, updateOptions , cameFrom}) {
  let uniqueId = Math.floor(Math.random()*100);
  const [isFMShowen, setIsFMShowen] = useState(false)
  const [selectedValue, setSelectedValue] = useState();
  const [showCkEditor, setShowCkEditor] = useState(true);
  const [tempEditorState, setTempEditorState] = useState(false);
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()

  const onEditorStateChange = (editorState) => setEditorState(editorState);

  const getBase64 = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  function uploadImageCallBack(file) {
    return new Promise((resolve, reject) => {
      getBase64(file)
        .then((data) => {
          resolve({ data: { link: data } });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  const handlePastedFiles = async (files) => {
    getBase64(files[0])
      .then((data) => {
        setEditorState(insertImage(data));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const insertImage = (url) => {
    const contentState = editorState.getCurrentContent();
    const contentStateWithEntity = contentState.createEntity("IMAGE", "IMMUTABLE", { src: url });
    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    const newEditorState = EditorState.set(editorState, { currentContent: contentStateWithEntity });
    return AtomicBlockUtils.insertAtomicBlock(newEditorState, entityKey, " ");
  };

  const styleMap = {
    'CODE': {
      color: `#ffffff`
    },
  };
  
  useEffect(() => {
    const updateData = async () => {
      if (selectedValue) {
        setShowCkEditor(false)
        let htmlTag = ``
        let extension = selectedValue.split('.').pop().toLowerCase()
        if (['mp3', 'wav', 'ogg', 'aac'].includes(extension)) {
          htmlTag = `<iframe frameborder="0" scrolling="no" src="https://${DOMAIN_COLOR}/ckEditorTags.html?path=${IMAGE_URL}/${selectedValue}&type=audio"></iframe>` // for live
        } else {
          htmlTag = `<iframe frameborder="0" scrolling="no" src="https://${DOMAIN_COLOR}/ckEditorTags.html?path=${IMAGE_URL}/${selectedValue}&type=video"></iframe>` // for live
        }
        let updateValue = (editorState ? editorState : "") + htmlTag
        if (updateOptions) {
          await updateOptions(updateValue)
          setShowCkEditor(true)
        } else {
          setEditorState(prevState => {
            return (updateValue)
          })
          setShowCkEditor(true)
        }
      }
    }
    if (selectedValue) {
      updateData()
    }
    const cleanUp = async () => {
      let htmlTag = ``
      if (selectedValue) {
        htmlTag = `<iframe frameborder="0" scrolling="auto" src="${IMAGE_URL}/${selectedValue}"></iframe>`
      }
      let updateValue = (editorState ? editorState : "") + htmlTag
      await updateOptions(updateValue)
    }
    return () => {
      if (selectedValue) {
        if (updateOptions) {
          cleanUp()
        } else {
          let htmlTag = ``
          if (selectedValue) {
            htmlTag = `<iframe frameborder="0" scrolling="auto" src="${IMAGE_URL}/${selectedValue}"></iframe>`
          }
          let updateValue = (editorState ? editorState : "") + htmlTag
          setEditorState(updateValue)
        }
      }
    }
  }, [tempEditorState])

  useEffect(() => {
    var audioTag = document.getElementById("myAudio");
    if (audioTag) {
      new Audio(audioTag).pause()
    }
  }, [editorState])

  useEffect(() => {
    if (initialValue && showCkEditor && isCKEditor) {
      // Force re-render to ensure initial state is displayed
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
      }, 0);
    }
  }, [initialValue, showCkEditor, isCKEditor]);

  if (loading) {
    return ""
  }

  return (
    <div>
      <div className="card-body-inr card-body-info">
        <div>
          <div className={!isInvalid ? ` ${!belowNoMargin ? "mb-4" : ""} editor-static ` : ` ${!belowNoMargin ? "mb-4" : ""} file-req is-invalid  `}>
            {isCKEditor ? 
            <>{showCkEditor ? <CKEditor
                initData={editorState || ""}
              onChange={({ editor }) => {
                if (updateOptions) {
                  updateOptions(editor.getData())
                  return
                }
                setEditorState(editor.getData());
              }}
              onPaste={({editor}) =>{
                setEditorState(editor.getData())
              }}
                onBlur={({ editor }) => {
                  if (editorState) { 
                    setEditorState(editor.getData());
                  }
              }}
              readOnly={false}
              onBeforeLoad={(CKEDITOR) => {
                let alreadyExist = CKEDITOR.plugins.get(`cstButton${uniqueId}`)
                if (!alreadyExist) {
                  CKEDITOR.plugins.add(`cstButton${uniqueId}`, {
                    icons: `cstButton${uniqueId}`,
                    init: function (editor) {
                      editor.ui.addButton(`CstButton${uniqueId}`, {
                        label: 'Audio/Video',
                        command: `cstButton${uniqueId}`,
                        toolbar: 'insert,10',
                        name: `cstbutton${uniqueId}`,
                        icon: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSaLO2_EFFI-eVhUBi6BS6XKE54viRbADMBb-xvh41zS7Pzk5Ts-fkAHrwIHdfZ2_vYE7g&usqp=CAU',
                      });
                    },
                  });
                }
                return (CKEDITOR.disableAutoInline = true)
              }}
              onBeforeDestroy={(CKEDITOR) => {
                if(CKEDITOR?.editor?.commands[`cstButton${uniqueId}`]){
                  CKEDITOR.editor.commands[`cstButton${uniqueId}`].disable();
                }
              }}
              onInstanceReady={({ editor }) => {
                // Add null check before calling .closest()
                const customButton = document.querySelector(`.cke_button__cstbutton${uniqueId}`);
                if (customButton) {
                  const toolbar = customButton.closest('.cke_toolbar');
                  if (toolbar) {
                    toolbar.classList.add('cke_clear_both');
                  }
                }
                
                let doc = document.querySelector(`.cke_button__cstbutton${uniqueId}`)
                if (doc) {
                  doc.addEventListener("click", () => {
                    setSelectedValue(prevState => false)
                    $("#editor-fs").modal("show");
                    setIsFMShowen(true)
                    setShowCkEditor(false)
                  })
                }
                
                let img = document.querySelector('.cke_button__image')
                if (img) {
                  img.addEventListener("click", () => {
                    dispatch(setFileSystemType('image'))
                  })
                }
                
                let embed = document.querySelector('.cke_button__link')
                if (embed) {
                  embed.addEventListener("click", () => {
                    dispatch(setFileSystemType('all'))
                  })
                }
                editor.setData(editorState || "");
              }}
              config={{
                allowedContent: true,
                entities:false,
                basicEntities: false,
                entities_greek: false, 
                entities_latin: false, 
                entities_additional: '', 
                preset:'full',
                extraPlugins:`forms,iframe,font,colordialog,colorbutton,embed,emoji,justify,bidi,exportpdf,templates,smiley,showblocks,selectall,scayt,find,entities,basicstyles,popup,uploadimage,codesnippet,cstButton${uniqueId},${ (from == "quizManagement" || from == "multiFormatCKEditor") ? 'mathjax' : ''}`,
                uploadUrl:`${API_BASE}/uploadEditorFiles`,
                embed_provider:'//ckeditor.iframe.ly/api/oembed?url={url}&callback={callback}',
                font_names: 'default;Arial;Comic Sans MS;Courier New;Georgia;Lucida Sans Unicode;Tahoma;Times New Roman;Trebuchet MS;Verdana;Segeo UI Light;',
                filebrowserUploadUrl:`${API_BASE}/uploadEditorFiles`,
                mathJaxLib: '//cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.5/MathJax.js?config=TeX-AMS_HTML',
                filebrowserBrowseUrl:`/fileSystem`,
                versionCheck: false ,
                toolbar: cameFrom === 'CTA_section' ? [
                  { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline'] },
                  { name: 'paragraph', items: ['NumberedList', 'BulletedList'] },
                  { name: 'undo', items: ['Undo', 'Redo'] },
                  { name: 'links', items: ['Link'] }
                ] : 'Full',
                toolbarGroups: cameFrom === 'CTA_section' ? [
                  { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
                  { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi'] },
                  { name: 'insert' }
                ] : null,
              }}
              onFileUploadRequest={async function( evt ) {
                var fileLoader = evt.data.fileLoader,
                    formData = new FormData(),
                    xhr = fileLoader.xhr;
                xhr.open( 'POST', fileLoader.uploadUrl, true );
                xhr.setRequestHeader( 'Authorization', `Bearer ${getToken()}` );
                formData.append( 'document', fileLoader.file, fileLoader.fileName);
                fileLoader.xhr.send( formData );
            
                // Prevented the default behavior.
                evt.stop();
            }}
            onFileUploadResponse={function( evt ) {
              // Prevent the default response handler.
              evt.stop();
          
              // Get XHR and response.
              var data = evt.data,
                  xhr = data.fileLoader.xhr,
                  response = xhr.responseText.split( '|' );
                  response[0] = IMAGE_URL + response[0].replace("home/myaie/public_html/", "").replace("public", "");
          
              if ( response[ 1 ] ) {
                  // An error occurred during upload.
                  data.message = response[ 1 ];
                  evt.cancel();
              } else {
                  data.url = response[ 0 ];
              }
              setEditorState(evt.editor.getData())
            } }
            /> : "" }
            <PopupComponent
            id="editor-fs"
            type="stateBasedCondition"
            header={{
              iconName:"fa-plus",
              heading: "File System"
            }}
            renderCondition={isFMShowen}
            setRenderCondition={setIsFMShowen}
            componentToRender = {<FileSystem setIsFMShowen={setIsFMShowen} isFMultiMedia={true} setSelectedValue={setSelectedValue} setTempEditorState={setTempEditorState} tempEditorState={tempEditorState} />}
            /> </>
            : <Editor
              readOnly={readOnly}
              defaultEditorState={editorState}
              editorState={editorState}
              editorClassName="editorClassName"
              onEditorStateChange={onEditorStateChange}
              handlePastedFiles={handlePastedFiles}
              toolbar={{
                image: { urlEnabled: true, uploadEnabled: true, uploadCallback: uploadImageCallBack },
                fontFamily: {
                  options: ['Arial', 'Georgia', 'Impact', 'Tahoma', 'Times New Roman', 'Verdana', 'Segoe UI Light'],
                },
                colorPicker: { component: ColorPic },
              }}
              customStyleMap={styleMap}
            />}
            {!hideSign && <div className="editor-static-blk">
              <h4></h4>
              <div className="editor-static-blk-info">
                <p>Kind Regards,</p>
                <br></br>
                <p>myAIE Student Support Team</p>
                <p>students@myaie.ac</p>
                <p>www.myaie.ac</p>
              </div>
            </div>}
          </div>
        </div>
      </div>
    </div>
  );
}

export default HtmlInputEditor;
